import APIClient from '@/apiClient'
import { useRoute } from 'vue-router'
import moment from 'moment';
import { useUserStore } from './user'

export const useSocketStore = defineStore('store', () => {
    const socket = ref(null)
    const userStore = useUserStore()
    const chats = ref(null)
    const no_readed_messages = ref(0)
    const initialize = () => {
        socket.value = new WebSocket('wss://'+window.location.hostname+'/ws/chat');

        // Событие открытия соединения
        socket.value.addEventListener('open', (event) => {
            console.log('WebSocket соединение открыто.');
            
            // Отправить сообщение на сервер
            socket.value.send(JSON.stringify({
                'type': 'auth',
                'payload': userStore.token
            }));
        });

        // Событие получения сообщения от сервера
        socket.value.addEventListener('message', (event) => {
            const message = JSON.parse(event.data);
            const payload = message.payload

            if(message.type == 'loading_chats') {
                chats.value = payload.chats
                no_readed_messages.value = payload.no_readed_messages
            }

            if(message.type == 'new_message') {
                for(let chat of chats.value) {
                    try {
                        chat.messages =  chat.messages.filter(o => o.id != -1)
                        if(parseInt(chat.id) == parseInt(payload.chat)) {
                            chat.messages.push(payload)
                        }
                    } catch(e) {

                    }
                }
            }
            nextTick(() => {
                let element = document.querySelector('.chat-body-area')
                if (element == null) return;
                element.scrollTop = element.scrollHeight
            })
            console.log('Получено сообщение от сервера:', payload);
        });

        // Событие закрытия соединения
        socket.value.addEventListener('close', (event) => {
            if (event.wasClean) {
                console.log('WebSocket соединение закрыто чисто, код: ' + event.code);
            } else {
                console.error('WebSocket соединение разорвано');
            }
        });

        // Событие ошибки
        socket.value.addEventListener('error', (error) => {
            console.error('WebSocket ошибка: ' + error);
        });
    }

    const sendMessage = (chat, type,  message, file=null) => {
        socket.value.send(JSON.stringify({
            'type': 'send_message',
            'payload': {chat: chat, message: message, type: type, file: file}
        }));
    }
  return {
    initialize,
    chats,
    sendMessage,
    no_readed_messages
  }
})
function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(cookieName) {
  const name = cookieName + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }

  return null; // Return null if the cookie with the specified name is not found
}